import styled from 'styled-components';
import { darken, lighten } from 'polished';

export const Container = styled.div`
  width: 100%;
  height: 45%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
`;

export const Header = styled.div`
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 5px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
`;

export const Titulo = styled.h4`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const Tabela = styled.table`
  width: 100%;
  height: 50px;
  font-size: 12px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.background};
  border-spacing: 0;

  thead {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.textPrimary};

    tr {
      th {
        width: 100%;
        padding: 5px;
        text-align: left;

        &:nth-child(2),
        &:nth-child(3) {
          text-align: center;
        }
      }
    }
  }

  tbody {
    tr {
      cursor: pointer;
      transition: 0.2s;
      background-color: ${({ theme }) => theme.colors.background};

      &:nth-child(odd) {
        background-color: ${({ theme }) => darken(0.025, theme.colors.background)};
      }

      td {
        padding: 5px;
        color: ${({ theme }) => theme.colors.textBackground};

        &:nth-child(2),
        &:nth-child(3) {
          text-align: center;
        }

        a {
          font-weight: bold;
          color: ${({ theme }) => theme.colors.textBackground};

          &:hover {
            color: ${({ theme }) => lighten(0.1, theme.colors.primary)};
            text-decoration: underline;
          }
        }
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
      }
    }
  }
`;
